import { render, staticRenderFns } from "./PermissionsCatalogue.vue?vue&type=template&id=72a2a822&scoped=true"
import script from "./PermissionsCatalogue.vue?vue&type=script&lang=js"
export * from "./PermissionsCatalogue.vue?vue&type=script&lang=js"
import style0 from "./PermissionsCatalogue.vue?vue&type=style&index=0&id=72a2a822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a2a822",
  null
  
)

export default component.exports